import React from 'react';

import auth, { Auth } from './modules/auth';
import locale, { Locale } from './modules/locale';
import facility, { Facility } from './modules/facility';
export type RootStore = {
  auth: Auth;
  locale: Locale;
  facility: Facility;
};

export const store: RootStore = {
  auth,
  locale,
  facility
};

const StoreContext = React.createContext<RootStore>(store);
export const StoreProvider = StoreContext.Provider;
export const useStore = () => React.useContext(StoreContext);

export { auth, locale, facility };
